import React, { useState } from 'react'
import { useUserInfo } from '../../Authentication/hooks'
import { Link, useNavigate } from 'react-router-dom'
import NavigationComponent from '../navigationComponent'
import {
  customPostRequest,
  validateGeneralCategoryData,
  createNavigationHandlers,
  handleAsyncError
} from './utils/categoryUtils'
import '../../../assets/stylesheets/kategories.css'

const WeddingCategory = () => {
  const [weddingName, setWeddingName] = useState('')
  const [weddingDate, setWeddingDate] = useState('')
  const [weddings, setWeddings] = useState([])
  const { userId } = useUserInfo()
  const [message, setMessage] = useState('')
  const [categoryCreated, setCategoryCreated] = useState(false)
  const navigate = useNavigate()
  const [annual, setAnnual] = useState(false)
  const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL
  const [showUpgradeLink, setShowUpgradeLink] = useState(false)

  const { handleHomeClick, handleUploadClick, handleSubscribeClick } =
    createNavigationHandlers(navigate)

  async function fetchUserSubscription(userId) {
    const url = `${API_GATEWAY_URL}/k1/users/${userId}`
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      })
      const data = await response.json()
      return {
        categoryCount: data.categoryCount,
        categoryLimit: data.subscription.categoryLimit
      }
    } catch (error) {
      console.error('Error fetching user subscription:', error)
      return null
    }
  }

  const handleCreate = async () => {
    if (!userId) {
      setMessage('User not authenticated')
      setShowUpgradeLink(false)
      return
    }

    if (!weddingName || !weddingDate) {
      setMessage('Please enter both wedding name and date')
      setShowUpgradeLink(false)
      return
    }

    try {
      const subscriptionData = await fetchUserSubscription(
        userId,
        API_GATEWAY_URL
      )
      if (!subscriptionData) {
        setMessage('Failed to fetch subscription data')
        setShowUpgradeLink(true)
        return
      }
      const { categoryCount, categoryLimit } = subscriptionData

      if (categoryCount >= categoryLimit) {
        setMessage('You have reached your category limit.')
        setShowUpgradeLink(true)
        return
      }
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'fetching category count')
      setMessage(`Failed to fetch category count: ${errorMessage}`)
      setShowUpgradeLink(true)
      return
    }

    const categoryData = {
      userId: userId,
      name: weddingName,
      type: 'event',
      subType: 'wedding',
      calendarAttrs: {
        fromDate: weddingDate + 'T00:00:00Z',
        toDate: weddingDate + 'T23:59:59Z',
        annual: annual
      }
    }

    if (!validateGeneralCategoryData(categoryData, setMessage)) {
      console.error('Invalid category data:', categoryData)
      return
    }

    try {
      const apiURL = `${process.env.REACT_APP_API_GATEWAY_URL}/k1/users/${userId}/categories`
      const responseData = await customPostRequest(apiURL, categoryData)

      if (responseData.error) {
        throw new Error(responseData.error)
      }

      setWeddings(prev => [...prev, { weddingName, weddingDate }])
      setWeddingName('')
      setWeddingDate('')
      setMessage('Category created successfully!')

      setCategoryCreated(true)
    } catch (error) {
      const errorMessage = handleAsyncError(error, 'creating category')
      setMessage(`Failed to create category: ${errorMessage}`)
    }
  }

  //Anniversary checkbox
  const handleAddAnniversaryToggle = () => {
    setAnnual(!annual)
  }

  return (
    <div className="wedding-category">
      <NavigationComponent handleHomeClick={handleHomeClick} />
      <h2 className="category-header">Wedding</h2>
      {message && <p className="message">{message}</p>}
      {showUpgradeLink && (
        <p>
          Please{' '}
          <span className="link-like" onClick={handleSubscribeClick}>
            upgrade
          </span>{' '}
          your plan.
        </p>
      )}
      {message === 'Category created successfully!' && (
        <p>
          <Link to="/gallery">Click here</Link> to return to the main gallery.
        </p>
      )}
      <input
        type="text"
        placeholder="Whose Wedding?"
        value={weddingName}
        onChange={e => setWeddingName(e.target.value)}
        className="input-field"
      />
      <input
        type="date"
        value={weddingDate}
        onChange={e => setWeddingDate(e.target.value)}
        className="input-field"
      />
      <label className="add-anniversary-button">
        <input
          type="checkbox"
          checked={annual}
          onChange={handleAddAnniversaryToggle}
          className="add-anniversary-checkbox"
        />
        <p>Add Anniversary Category</p>
      </label>
      <div className="button-group">
        <button onClick={handleCreate} className="create-button">
          Create
        </button>
      </div>
      {categoryCreated && (
        <div className="list_and_upload">
          <ul>
            {weddings.map((wedding, index) => (
              <li className="added-list" key={index}>
                {wedding.weddingName} - {wedding.weddingDate}
              </li>
            ))}
          </ul>
          <button className="upload-button-list" onClick={handleUploadClick}>
            Upload Photos
          </button>
        </div>
      )}
    </div>
  )
}

export default WeddingCategory
